var map = {
	"./ANIMALS.png": 98312,
	"./ANIME.png": 40765,
	"./CLASSIC.png": 33037,
	"./COUNTRIES.png": 19523,
	"./DRAGONBALL.png": 11682,
	"./FOODS.png": 21789,
	"./HALLOWEEN.png": 10696,
	"./HEARTHSTONE.png": 15103,
	"./HISTORICAL_FIGURES.png": 11956,
	"./LEAGUE_OF_LEGENDS.png": 67252,
	"./MELAGOODO.png": 25588,
	"./POKEMON.png": 29703,
	"./POKEMON_GEN2.png": 46446,
	"./POKEMON_GEN3.png": 67097,
	"./POKEMON_GEN4.png": 4653,
	"./POKEMON_GEN5.png": 48731,
	"./POKEMON_GEN6.png": 60264,
	"./POKEMON_GEN7.png": 25663,
	"./SIMPSONS.png": 4683,
	"./SMORFIA.png": 8533,
	"./SOCCER_PLAYERS.png": 46098,
	"./SUPERHEROES.png": 48213,
	"./TV_SERIES.png": 38323,
	"./WINTER.png": 94225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34383;